import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import "./css/App.css";
import "./css/CoursePage.css";
import PageTenseDetails from "./Component/PageTense/PageTenseDetails.js";
import PageLoginRegister from "./Component/Auth/PageLoginRegister.js";
import PageQuiz from "./Component/PageQuiz/PageQuiz.js";
import ToeicPage from "./Component/PageMap/ToeicPage.js";
import CondMap from "./Component/PageMap/CondMap.js";
import FutureMap from "./Component/PageMap/FutureMap.js";
import ModEdMap from "./Component/PageMap/ModEdMap.js";
import ModMap from "./Component/PageMap/ModMap.js";
import Home from "./Component/Home.js";
import PageNotepad from "./Component/PageNotePad/PageNotepad.js";
// import PageCreatePassword from "./Component/PageCreatePassword.js";
import PageAddCourse from "./Component/PageAddCourse";
import PageProfessor from "./Component/PageProfessor/PageProfessor.js";
import PageAdminTenseMap from "./Component/PageAdmin/PageAdminTenseMap.js";
import AdminUserManagement from "./Component/PageAdmin/AdminUserManagement.js";
import AdminRoleRequests from "./Component/PageAdmin/AdminRoleRequests.js";
import PageContact from "./Component/PageContact.js";
import AboutUs from "./Component/Company/AboutUs.js";
import Careers from "./Component/Company/Careers.js";
import Profile from "./Component/PageProfile.js";
import PrivacyPolicy from "./Component/Legal/PrivacyPolicy.js";
import CookiePolicy from "./Component/Legal/CookiePolicy.js";
import TermsOfService from "./Component/Legal/TermsOfService.js";
import AdminControlPanel from "./Component/PageAdmin/AdminControlPanel.js";
import QuizBuilder from "./Component/PageAdmin/QuizBuilder.js";
import PageCourseMod from "./Component/PageAdmin/PageCourseMod.js";
import FormAddCourse from "./Component/PageAdmin/FormAddCourse.js";
import FormAddQuestion from "./Component/PageAdmin/FormAddQuestion.js";
import VocabularyContextProvider from "./Contexts/VocabularyContext";
import { ClientColyseusProvider } from "./Contexts/ClientColyseusContext";
import ProgressTracker from "./Component/ProgressTracker/ProgressTracker";
import ProtectedRoute from "./protected.route";
import { withRouter } from "react-router-dom";
import { DictionaryContext } from "./Contexts/DictionaryContext.js";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./Contexts/AuthContext";
import Layout from "./Component/Layout/Layout";
import FourOhFour from "./Component/404/404";
import SpeedGame from "./Component/PageMultiplayer/SpeedGame";
import DeepLinkJoinRoom from "./Component/PageMultiplayer/DeepLinkJoinRoom";
import AdminAnalytics from "./Component/PageAdmin/AdminAnalytics.js";
import CourseQuestionAnalytics from "./Component/PageAdmin/CourseQuestionAnalytics.js";
import StudentDashboard from "./Component/student/StudentDashboard.js";
import FAQ from "./Component/Support/FAQ.js";
import Feedback from "./Component/Support/Feedback.js";
import HelpCenter from "./Component/Support/HelpCenter.js";
import TenseMapSVG from "./Component/SVGs/TenseMapSVG.js";
import GuestDashboard from "./Component/Guest/GuestDashboard.js";
import TensePreview from "./Component/Guest/TensePreview.js";
import ProgressPreview from "./Component/Guest/ProgressPreview.js";
import QuizPreview from "./Component/Guest/QuizPreview.js";
import RoleRequestPage from "./Component/Guest/RoleRequestPage.js";
import TensePractice from "./Component/PageTense/TensePractice.js";
import ApiClient from "./utils/api";
import PageCourse from "./Component/PageTense/PageTenseDetails.js";
import PageQuestionMod from "./Component/PageAdmin/PageQuestionMod.js";
import StudentNotepad from "./Component/student/StudentNotepad.js";
import { getSessionId } from "./utils/session";

const api = new ApiClient();

class App extends React.Component {
  // Word lookups (meaning + saving to the vocabulary) are owned by
  // VocabularyLookupWrapper, which shows the definition in a popup. This class
  // used to register a second document-level dblclick handler that answered with
  // a native alert() and only saved when a "sessionId" key happened to exist, so
  // double-clicking a word produced an alert and swallowed (or duplicated) the
  // popup's own save. It is deliberately gone.
  static contextType = DictionaryContext;

  componentDidMount() {
    // Generate session ID for anonymous users if one doesn't exist
    const token = localStorage.getItem("jstoken");
    if (!token) {
      let sessionId = localStorage.getItem("session");
      if (!sessionId) {
        // Create a unique session ID for the anonymous user
        sessionId = getSessionId();
        localStorage.setItem("session", sessionId);
      }
    }

    // Track word lookups in backend if user is logged in
    const { fetchWordMeaning } = this.context;
    const originalFetchWordMeaning = fetchWordMeaning;

    // Extend fetchWordMeaning to also log the lookup in the backend
    this.context.fetchWordMeaning = async (word) => {
      // Call the original function to show definition
      originalFetchWordMeaning(word);

      // Log the word lookup to backend if user is logged in
      if (localStorage.getItem("jstoken")) {
        try {
          const data = await api.post("/dictionnary", { word });
          console.log("Word saved to dictionary:", data);
        } catch (error) {
          console.error("Error saving word to dictionary:", error);
        }
      }
    };
  }

  componentWillUnmount() {
    /* nothing global to detach: word lookup lives in VocabularyLookupWrapper */
  }

  render() {
    return (
      <AuthProvider>
        <div className="App min-h-screen bg-gray-100">
          <meta
            httpEquiv="Cache-Control"
            content="no-cache, no-store, must-revalidate"
          />
          <meta httpEquiv="Pragma" content="no-cache" />
          <meta httpEquiv="Expires" content="0" />
          <Toaster position="top-right" />
          <VocabularyContextProvider>
            <Layout>
              <Switch>
                {/* Multiplayer is for signed-in players: a guest has no identity to
                    score against, and the game pairs people with real accounts. */}
                <ProtectedRoute
                  exact
                  path="/multiplayer"
                  component={SpeedGame}
                  userTypes={[1, 2, 3]}
                />
                <ProtectedRoute
                  path="/multiplayer/room/:roomId"
                  component={DeepLinkJoinRoom}
                  userTypes={[1, 2, 3]}
                />
                {/* Public routes */}
                {/* <Route exact path="/" component={Home} /> */}
                <Route exact path="/contact" component={PageContact} />
                <Route exact path="/about" component={AboutUs} />
                <Route exact path="/careers" component={Careers} />
                <Route exact path="/privacy" component={PrivacyPolicy} />
                <Route exact path="/cookies" component={CookiePolicy} />
                <Route exact path="/terms" component={TermsOfService} />
                {/* Admin-only routes - protected with userTypes=[1] */}
                <ProtectedRoute
                  path="/quizbuilder"
                  component={QuizBuilder}
                  userTypes={[1]}
                />
                <ProtectedRoute
                  path="/admintensemap"
                  component={PageAdminTenseMap}
                  userTypes={[1]}
                />
                <ProtectedRoute
                  path="/adminusers"
                  component={AdminUserManagement}
                  userTypes={[1]}
                />
                <ProtectedRoute
                  path="/admincontrolpanel"
                  component={AdminControlPanel}
                  userTypes={[1]}
                />
                <ProtectedRoute
                  path="/adminrolerequests"
                  component={AdminRoleRequests}
                  userTypes={[1]}
                />
                <ProtectedRoute
                  path="/adminanalytics"
                  component={AdminAnalytics}
                  userTypes={[1]}
                />
                <ProtectedRoute
                  path="/admin/course-analytics"
                  component={CourseQuestionAnalytics}
                  userTypes={[1]}
                />
              
                {/* Teacher routes - protected for teachers and admins */}
                {/* <ProtectedRoute
                  path="/professor"
                  component={PageProfessor}
                  userTypes={[1, 2]}
                /> */}
                {/* <ProtectedRoute
                  path="/dashboard"
                  component={StudentDashboard}
                /> */}
                {/* Routes for authenticated users of any role */}
                <ProtectedRoute path="/profile" component={Profile} />
                <ProtectedRoute path="/progress" component={ProgressTracker} />
                <ProtectedRoute
                  path="/tense/:tenseId/progress"
                  render={({ match }) => (
                    <ProgressTracker tenseId={match.params.tenseId} />
                  )}
                />
                {/* <ProtectedRoute path="/notepad" component={PageNotepad} /> */}
                <ProtectedRoute path="/notepad" component={StudentNotepad} />
                {/* Guest routes - protected for users with guest role (4) */}
                <ProtectedRoute
                  path="/guest"
                  exact
                  component={GuestDashboard}
                  userTypes={[4]}
                />
                <ProtectedRoute
                  path="/guest/tenses"
                  component={TensePreview}
                  userTypes={[4]}
                />
                <ProtectedRoute
                  path="/guest/quizzes"
                  component={QuizPreview}
                  userTypes={[4]}
                />
                <ProtectedRoute
                  path="/guest/progress"
                  component={ProgressPreview}
                  userTypes={[4]}
                />
                <ProtectedRoute
                  path="/guest/request-role"
                  component={RoleRequestPage}
                  userTypes={[4]}
                />
                {/* Public routes */}
                <Route
                  exact
                  path="/login_register"
                  component={PageLoginRegister}
                />
                <Route exact path="/" component={TenseMapSVG} />
                <Route exact path="/toeicpage" component={ToeicPage} />
                <Route exact path="/map/cond" component={CondMap} />
                <Route exact path="/map/future" component={FutureMap} />
                <Route exact path="/map/mod" component={ModMap} />
                <Route exact path="/map/mod past" component={ModEdMap} />
                <Route exact path="/quiz" component={PageQuiz} />
                <Route
                  exact
                  path="/tense/:title"
                  component={PageTenseDetails}
                />
                <Route
                  exact
                  path="/tense/:tenseId/practice"
                  component={TensePractice}
                />
                <Route exact path="/course/:tense" component={PageCourse} />
                <Route exact path="/quiz/:course" component={PageQuiz} />
                <ProtectedRoute
                  path="/addcourse"
                  component={PageAddCourse}
                  userTypes={[1]}
                />
                <Route path="/admincourse" component={PageCourseMod} />
                <Route path="/addquestion" component={FormAddQuestion} />
                {/* <Route path="/addquestion" component={PageQuestionMod} /> */}
                <Route exact path="/faq" component={FAQ} />
                <Route exact path="/feedback" component={Feedback} />
                <Route exact path="/help-center" component={HelpCenter} />
                {/* 404 route */}
                <Route path="/404" component={FourOhFour} />
                <Redirect to="/404" />
              </Switch>
            </Layout>
          </VocabularyContextProvider>
        </div>
      </AuthProvider>
    );
  }
}

const AppWithColyseus = (props) => (
  <ClientColyseusProvider>
    <App {...props} />
  </ClientColyseusProvider>
);

export default withRouter(AppWithColyseus);
